module.exports = __webpack_public_path__ + "img/video_menu_video_on.a79f97f3.svg";